import type { ProductId, StoreId } from 'shared/domain';

export function extractIdsFromParameters(parameters?: string) {
  if (!parameters) return { storeId: NaN, productId: NaN };
  let storeId: StoreId = NaN;
  let productId: ProductId = NaN;
  const cleanParams = parameters.replace(/^\[|\]$/g, '');
  const paramPairs = cleanParams.split(',');
  paramPairs.forEach(pair => {
    const [key, value] = pair.split('=');
    if (key?.trim() === 'store_id') {
      storeId = Number(value) as StoreId;
    } else if (key?.trim() === 'product_id') {
      productId = Number(value) as ProductId;
    }
  });
  return { storeId, productId };
}
